import {FidgetSpinner} from "react-loader-spinner";
import React from "react";
import {useSpinner} from "../context/SpinnerContext";

export const Spinner = () => {
    const {isVisible} = useSpinner();
    if (!isVisible) {
        return null;
    }
    return (
        <div className="flex flex-row justify-content-center align-items-center w-full h-full mt-10"
             style={{
                 zIndex: 9999,
                 position: 'fixed',
                 backgroundColor: 'rgba(0,0,0,0.2)'
             }}>
            <FidgetSpinner
                visible={true}
                height="80"
                width="80"
                ariaLabel="fidget-spinner-loading"
                wrapperStyle={{}}
                wrapperClass="fidget-spinner-wrapper"
            />
        </div>
    )
};